<template>
  <v-container>
  <v-card elevation="2" rounded="lg" color="#F5F5F5">
    <v-card-title class="d-flex flex-wrap align-center py-4" style="color:#AF8936">
      <div class="mr-4">
        <h2 class="hidden-sm-and-down" style="font-weight:700; letter-spacing:0.2px;">{{formTitle}}</h2>
        <h2 class="hidden-md-and-up" style="font-weight:700; font-size:18px;">{{formTitle}}</h2>
        <div v-if="currentUser.sala" class="d-flex align-center mt-1">
          <v-icon small color="#225883" class="mr-1">mdi-map-marker</v-icon>
          <span style="color:#225883; font-size:13px; font-weight:600;">{{ currentUser.sala.nombre }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-wrap" style="gap:8px;">
        <v-btn v-if="roleUser=='superadmin' || roleUser=='abogado'" small depressed color="#0A4A79" dark to="/promociones/firma">
          <v-icon small left>mdi-plus</v-icon> Presentar Escrito
        </v-btn>
        <v-btn v-if="roleUser=='superadmin'" small depressed color="#0A4A79" dark to="/escritos/panel">
          <v-icon small left>mdi-file-document-outline</v-icon> Sentencias y Amparos
        </v-btn>
        <v-btn v-if="roleUser=='superadmin'" small depressed color="#0A4A79" dark to="/panel">
          <v-icon small left>mdi-view-dashboard-outline</v-icon> {{btnTitle}}
        </v-btn>
      </div>
    </v-card-title>

    <v-form class="mx-4 mx-md-5" ref="search" v-model="validateToca" lazy-validation>
      <v-card outlined rounded="lg" elevation="1" class="mt-2">
        <v-card-text class="pb-3">
          <div class="d-flex align-center mb-3">
            <v-icon color="#0A4A79" class="mr-2">mdi-filter-outline</v-icon>
            <span class="font-weight-bold" style="color:#0A4A79; font-size:14.5px; letter-spacing:0.5px;">FILTROS</span>
            <v-divider class="mx-3"></v-divider>
            <!-- <span class="grey--text hidden-sm-and-down" style="font-size:13px;">Refina tu búsqueda</span> -->
          </div>
          <v-row dense>
            <v-col v-if="sala_id <= 11" cols="12" :md="(roleUser != 'magistrado' || roleUser != 'secacuerdos') && !currentUser.sala_id ? 3 : 6">
              <v-text-field
                v-model="no_toca"
                label="Toca"
                placeholder="1234/2024"
                prepend-icon="mdi-folder-outline"
                clearable
                outlined
                dense
                class="mb-2"
                style="font-size:15px;"
                @blur="clear()"
                :rules="tocaRules"
                >
              </v-text-field>
            </v-col>
            <v-col v-if="sala_id == 12" cols="12" :md="!currentUser.sala_id ? 3 : 6">
              <v-text-field
                v-model="no_expediente"
                label="Asunto"
                placeholder="1234/2024"
                prepend-icon="mdi-folder-outline"
                clearable
                outlined
                dense
                class="mb-2"
                style="font-size:15px;"
                :rules="tocaRules"
                @blur="clear()"
                >
              </v-text-field>
            </v-col>
            <v-col cols="12" :md="roleUser != 'magistrado' && !currentUser.sala_id ? 3 : 6">
              <v-select
                :items="listStatus"
                v-model="status"
                label="Estatus"
                prepend-icon="mdi-file-alert-outline"
                item-value="id"
                item-text="nombre"
                clearable
                outlined
                dense
                hide-details="auto"
                class="mb-2"
                style="font-size:15px;"
                >
              </v-select>
            </v-col>
            <v-col v-if="validUser && !currentUser.sala_id && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" cols="12" md="6">
              <v-select
                v-model="sala_id"
                :items="listSalas"
                label="Área"
                prepend-icon="mdi-map-marker"
                item-value="id"
                item-text="nombre"
                outlined
                clearable
                :disabled="!validUser"
                dense
                hide-details="auto"
                class="mb-2"
                style="font-size:15px;"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="sala_id != 13" dense class="mt-n7">
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" class="d-flex justify-end">
              <v-btn depressed color="#0A4A79" :disabled="!validateToca" @click="clickSearch()" class="px-6 white--text btn-buscar" style="min-width:140px; height:40px; font-size:14px; letter-spacing:0.5px;">
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card outlined rounded="lg" elevation="1" class="mt-4">
        <div v-if="roleUser == 'abogado'">
          <v-card flat rounded="lg" class="mb-1" style="border:1px solid #E0E0E0;">
            <div class="text-center py-2" style="background:#FAFAFA; border-bottom:1px solid #EEEEEE;">
              <span class="font-weight-bold" style="color:#225883; font-size:14px; letter-spacing:0.8px;">CONTESTACIONES PENDIENTES</span>
            </div>
            <v-tabs
              v-model="active_tab"
              background-color="white"
              color="#0A4A79"
              centered
              icons-and-text
              show-arrows
              height="68"
            >
              <v-tabs-slider color="#0A4A79"></v-tabs-slider>
              <v-tab href="#tab-1" @click="sala_id=''" style="font-size:13.5px; letter-spacing:0.2px;">
                Promociones de salas
                <v-badge v-if="pendientesLeer.promociones > 0" :content="pendientesLeer.promociones" color="red" overlap class="ml-2">
                   <v-icon small>mdi-email</v-icon>
                </v-badge>
                <v-icon v-else small>mdi-email-outline</v-icon>
              </v-tab>

              <v-tab href="#tab-2" @click="sala_id=12" style="font-size:13.5px; letter-spacing:0.2px;">
                Asuntos Laborales
                <v-badge v-if="pendientesLeer.expedientes_laboral > 0" :content="pendientesLeer.expedientes_laboral" color="red" overlap class="ml-2">
                   <v-icon small>mdi-folder</v-icon>
                </v-badge>
                <v-icon v-else small>mdi-folder-outline</v-icon>
              </v-tab>

              <v-tab href="#tab-3" @click="sala_id=13" style="font-size:13.5px; letter-spacing:0.2px;">
                  Buzón Presidencia
                <v-badge v-if="pendientesLeer.buzon > 0" :content="pendientesLeer.buzon" color="red" overlap class="ml-2">
                   <v-icon small>mdi-mailbox-up</v-icon>
                </v-badge>
                <v-icon v-else small>mdi-mailbox-outline</v-icon>
              </v-tab>
            </v-tabs>
          </v-card>
        </div>

        <div v-if="showAlert" class="mx-3 mt-3">
          <v-alert
            dense
            border="left"
            colored-border
            color="warning"
            icon="mdi-information-outline"
            class="mb-2"
           >
            <span style="font-size:14px;">No se encontraron registros relacionados con la búsqueda.</span>
          </v-alert>
        </div>
          <template>
            <v-card-title class="d-flex align-center py-3 px-4" style="color:#0A4A79; border-bottom:1px solid #F0F0F0;">
              <v-icon color="#0A4A79" class="mr-2">mdi-table-large</v-icon>
              <span style="font-size:16.5px; font-weight:700; letter-spacing:0.2px;">{{ titleTabla }}</span>
              <v-spacer></v-spacer>
              <!-- <v-chip small outlined color="#0A4A79" class="hidden-sm-and-down" style="font-size:13px;">{{ listData.length }} registros</v-chip> -->
            </v-card-title>

                <v-data-table
                  dense
                  align="left"
                  :loading="loadingTable"
                  loading-text="Cargando registros..."
                  :headers="headers"
                  :items="listData"
                  item-key="id"
                  :page.sync="page"
                  :items-per-page="per_page_table"
                  hide-default-footer
                  no-data-text="No se Encontraron Registros"
                  class="elevation-0"
                  :header-props="{ sortByText: 'Ordenar por' }"
                  @page-count="pageCount = $event"
                >
                <template v-slot:item.status_secacuerdos="{ item }">
                  <div class="">
                    <v-tooltip v-if="item.status == 2  && roleUser == 'secretariageneral'" left>

                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-sim-alert</v-icon>
                      </template>
                      <span>Pendiente</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.status == 3 && roleUser == 'secretariageneral'" left>

                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>
                    {{ item.numero_completo}}
                  </div>
                </template>

                <template v-slot:item.numero_completo="{ item }">
                <v-tooltip v-if="item.status == 2 && roleUser == 'abogado'" left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      left
                      color="grey"
                      v-on="on"
                      >
                    mdi-file-clock-outline</v-icon>
                  </template>
                  <span>Pendientes de contestación</span>
                </v-tooltip>
                <v-tooltip v-if="(item.status == 3 && item.contestacion_leida == 0) && (roleUser == 'abogado')" left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      left
                      color="#E65100"
                      v-on="on"
                      >
                    mdi-email-alert</v-icon>
                  </template>
                  <span>Pendientes por leer</span>
                </v-tooltip>
                <v-tooltip v-if="(item.status == 3 && item.contestacion_leida == 1 ) && (roleUser == 'abogado')"  left>
                  <!-- <v-tooltip left> -->
                  <template v-slot:activator="{ on }">
                    <v-icon
                      left
                      color="green"
                      v-on="on"
                      >
                    mdi-check-circle-outline</v-icon>
                  </template>
                  <span>Contestada</span>
                </v-tooltip>
                {{ item.numero_completo}}
              </template>

              <template v-slot:item.area="{ item }">
                <td><span>Sala {{item.sala_id}}</span></td>
              </template>

                <template v-slot:item.abogado="{ item }">
                  <span v-if="item.abogado">Abogado: {{item.abogado}}</span><br>
                </template>

                <template v-slot:item.status="{ item }">
                  <td v-if="item.status == 2 && item.firma_magistrado == 0" style="font-size:14px;">
                    <v-icon small color="red" class="mr-1">mdi-file-remove</v-icon>Pendiente de firma
                  </td>
                  <td v-else-if="item.status == 2 && item.firma_magistrado == 1" style="font-size:14px;">
                    <v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>Firmado
                  </td>
                  <td v-else-if="item.status == 2" style="font-size:14px;">Registrada</td>
                  <td v-if="item.status == 3" style="font-size:14px;">
                    <v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>Contestada
                  </td>
                </template>

                <template v-slot:item.fechas="{ item }" >
                  <td style="font-size:13.5px; line-height:1.5; min-width:170px;">
                    <div v-if="item.fecha_contestacion" class="d-flex align-center mb-2"><v-icon small color="green" class="mr-2">mdi-check-circle-outline</v-icon> <span>Contestación: {{item.fecha_contestacion | formatDate}}</span></div>
                    <div class="d-flex align-center"><v-icon small color="#0A4A79" class="mr-2">mdi-calendar</v-icon> <span>Registrada: {{item.created_at | formatDate}}</span></div>
                  </td>
                </template>
                <template v-slot:item.action="{ item }">
                  <div class="d-flex flex-wrap py-1" style="gap:6px;">
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" dark x-small color="green" @click="showPromocion(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver promoción
                  </v-btn>
                  <v-btn v-if="(sala_id <= 11 || sala_id == '') && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" dark x-small color="indigo" class="ml-1" @click="showToca(item)">
                    <v-icon small dark left>mdi-folder</v-icon>
                    Ver Historial
                  </v-btn>
                  <v-btn v-if="sala_id == 12" dark x-small color="green" @click="showExpediente(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver asunto
                  </v-btn>
                  <v-btn v-if="(sala_id == 12) && (roleUser != 'magistrado' || roleUser != 'secacuerdos')" dark x-small color="indigo" class="ml-1" @click="showHistorialExp(item)">
                    <v-icon small dark left>mdi-folder</v-icon>
                    Ver Historial
                  </v-btn>
                  <v-btn v-if="sala_id == 13" dark x-small color="green" @click="showBuzon(item)">
                    <v-icon small dark left>mdi-file</v-icon>
                    Ver escrito
                  </v-btn>
                  </div>
                </template>

                  <template v-if="sala_id == 13" v-slot:item.asunto="{ item }">
                    <v-tooltip v-if="(item.fecha_contestacion == null) && roleUser == 'presidencia'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-sim-alert</v-icon>
                      </template>
                      <span>Pendientes</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.fecha_contestacion && roleUser == 'presidencia'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>

                    <v-tooltip v-if="(item.buzones_pendientes_leer == 0 && item.fecha_contestacion != null)  && roleUser == 'abogado'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="#E65100"
                          v-on="on"
                          >
                        mdi-email-alert</v-icon>
                      </template>
                      <span>Pendientes por leer</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.fecha_contestacion && item.buzones_pendientes_leer > 0 && roleUser == 'abogado'" left>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          left
                          color="green"
                          v-on="on"
                          >
                        mdi-check-circle-outline</v-icon>
                      </template>
                      <span>Contestada</span>
                    </v-tooltip>
                      <v-tooltip v-if="item.fecha_contestacion == null && roleUser == 'abogado'" left>
                        <!-- <v-tooltip left> -->
                        <template v-slot:activator="{ on }">
                          <v-icon
                            left
                            color="grey"
                            v-on="on"
                            >
                          mdi-file-clock-outline</v-icon>
                        </template>
                        <span>Pendiente de Contestación</span>
                      </v-tooltip>
                      {{ item.asunto}}
                    <!-- </div> -->
                  </template>
                  <template v-if="sala_id == 13" v-slot:item.abogado="{ item }">
                    <span v-if="item.abogado">Abogado: {{item.abogado}}</span><br>
                  </template>


                </v-data-table>
                <div class="text-center py-3" style="border-top:1px solid #F0F0F0;">
                  <v-pagination
                    v-if="pagination.total > 1"
                    v-model="pagination.current"
                    :length="pagination.total"
                    :total-visible="7"
                    @input="onPageChange"
                    color="#0A4A79"
                    circle
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  ></v-pagination>
                </div>
          </template>
      </v-card>
    </v-form>

    <v-row justify="space-around">
      <v-col cols="auto">
       <v-dialog
         v-model="dialog"
         persistent
         max-width="800"
         content-class="rounded-lg"
       >
         <template>
           <v-card rounded="lg">
             <v-toolbar
               color="#0A4A79"
               dense
               dark
               flat
             >
               <v-icon small class="mr-2">mdi-history</v-icon>
               <span class="font-weight-medium" style="font-size:14px;">{{historialTitle}}</span>
             <v-spacer></v-spacer>
               <v-btn
                 icon
                 small
                 @click="close()"
               >
                 <v-icon small>mdi-close</v-icon>
               </v-btn>
           </v-toolbar>
            <div v-if="numero_completo" class="px-4 py-2 d-flex align-center" style="background:#FAFAFA; border-bottom:1px solid #EEEEEE;">
              <v-icon small color="#0A4A79" class="mr-2">mdi-folder-outline</v-icon>
              <span class="caption font-weight-bold" style="color:#0A4A79;">{{ sala_id == 12 ? 'Registro del Asunto ' : 'Registro del Toca ' }}{{numero_completo}}</span>
              <v-spacer></v-spacer>
              <!-- <span class="caption grey--text">{{ listHistorial.length }} registros</span> -->
            </div>

            <v-data-table
              dense
              align="left"
              :loading="loadingHistorial"
              loading-text="Cargando historial..."
              :headers="headersHistorial"
              :items="listHistorial"
              item-key="id"
              :page.sync="page"
              :items-per-page="per_page_table_historial"
              hide-default-footer
              no-data-text="No se Encontraron Registros"
              class="elevation-0"
              @page-count="pageCount = $event"
            >
            <template v-slot:item.status="{ item }">
              <td v-if="item.status == 2" style="font-size:14px;">Registrada</td>
              <td v-if="item.status == 3" style="font-size:14px;"><v-icon small color="green" class="mr-1">mdi-check-circle-outline</v-icon>Contestada</td>
            </template>

            <template v-slot:item.area="{ item }" >
              <td><span style="font-size:14px;">Sala {{item.sala_id}}</span></td>
            </template>

            <template  v-slot:item.fechas="{ item }" >
              <td style="font-size:13.5px; line-height:1.5; min-width:170px;">
                <div v-if="item.fecha_contestacion" class="d-flex align-center mb-2"><v-icon small color="green" class="mr-2">mdi-check-circle-outline</v-icon> <span>Contestación: {{item.fecha_contestacion | formatDate}}</span></div>
                <div class="d-flex align-center"><v-icon small color="#0A4A79" class="mr-2">mdi-calendar</v-icon> <span>Registrada: {{item.created_at | formatDate}}</span></div>
              </td>
            </template>

            <template v-slot:item.acciones="{ item }">
              <v-btn depressed x-small color="#2E7D32" dark class="px-2" @click="showPromocion(item)">
                <v-icon x-small left>mdi-file-eye-outline</v-icon>
                Ver promoción
              </v-btn>
            </template>
            <template v-slot:item.accionesExp="{ item }">
              <v-btn depressed x-small color="#2E7D32" dark class="px-2" @click="showExpediente(item)">
                <v-icon x-small left>mdi-file-eye-outline</v-icon>
                Ver Asunto
              </v-btn>
            </template>

          </v-data-table>
          <div class="text-center py-3" style="border-top:1px solid #F0F0F0;">
            <v-pagination
              v-if="paginationHistorial.total > 1"
              v-model="paginationHistorial.current"
              :length="paginationHistorial.total"
              :total-visible="7"
              @input="onPageChangeHistorial"
              color="#0A4A79"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </div>
           </v-card>
         </template>
       </v-dialog>
     </v-col>
   </v-row>
  </v-card>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from 'vuex'
  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      per_page_table: 1,
      per_page_table_historial: 1,
      pagination: {
        current: 1,
        total: 0
      },
      paginationHistorial: {
        current: 1,
        total: 0
      },
      alert: true,
      dialog:false,
      valid: true,
      validUser: true,
      validateJuez: true,
      validateToca:true,
      loading:false,
      leidos: '',
      turnados: '',
      tipo: '2',
      href:'',
      status:'',
      sala_id:'',
      no_toca: '',
      toca_id: '',
      numero_completo: '',
      no_expediente: '',
      countPromociones: '',
      showTabla: false,
      showAlert: false,
      isExpanded:false,
      expand:false,
      expanded: [],
      singleExpand:true,
      titleTabla: 'REGISTROS:',
      juez:'',
      promocion_id:'',
      listHistorial: [],
      listData: [],
      listTocas: [],
      active_tab:'',
      pendientesLeer:'',
      loadingTable: false,
      loadingHistorial: false,
      tipoPromocion: [
        { id:'1', nombre: 'Demandas Familiares'},
        { id:'2', nombre: 'Promociones' }
      ],
      tocaRules: [
        v => !v || /^(\d+)(\/)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
      ],
      // listStatus: [
      //   { id: '1', nombre: 'Registrada' },
      //   { id: '2', nombre: 'Contestada' }
      // ],
    }),
    computed: {
      formTitle () {
        if (this.sala_id === 12) {
          return 'Panel de Asuntos Laborales'
        } else if (this.sala_id === 13) {
          return 'Panel de Buzón Presidencia'
        } else if (this.roleUser == 'magistrado') {
          return 'Panel de Acuerdos'
        }
        return 'Panel de Promociones'
      },
      btnTitle () {
        if (this.roleUser == 'magistrado') {
          return 'Acuerdos'
        }
        return 'Promociones'
      },
      historialTitle () {
        if (this.sala_id <= 11) {
          return 'Promociones del Toca ' + this.numero_completo
        } else if (this.sala_id === 12) {
          return 'Asunto Laboral '+ this.numero_completo
        }
      },
      listStatus(){
        if (this.roleUser == 'magistrado') {
          return [
            { id: '0', nombre: 'Pendiente de Firma' },
            { id: '1', nombre: 'Firmado' }
          ]
        } else {
          return [
            { id: '2', nombre: 'Registrada' },
            { id: '3', nombre: 'Contestada' }
          ]
        }
      },
      headers(){
        // if (this.roleUser == 'magistrado' && (this.sala_id <= 11 || this.sala_id == '')) {
        //   return [
        //     { text: 'Toca', value: 'numero_completo' },
        //     { text: 'Área', value: 'area' },
        //     { text: 'Estatus', value: 'status', sortable: false },
        //     // { text: 'Registro de fechas', value: 'fechas' },
        //     { text: 'Acciones', value: 'action', sortable: false }
        //   ]
        // }

        if (this.roleUser == 'abogado' && (this.sala_id <= 11 || this.sala_id == '')) {
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false }
          ]
        }
        if (this.roleUser == 'abogado' && this.sala_id == 12 ){
          return [
            { text: 'Asunto', value: 'numero_completo', class: "title" },
            // { text: 'Fecha de Turno', value: 'old_fecha_turno', class: "title" },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', class: "title",  align: 'left', sortable: false },
            { text: '' },
          ]
        }
        if (this.sala_id == 13 ){
          return [
            { text: 'Asunto', value: 'asunto', class: "title" },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', class: "title",  align: 'left', sortable: false },
            { text: '' },
          ]
        }

        if (this.roleUser != 'abogado' && (this.sala_id <= 11 || this.sala_id == '')) {
          return [
            { text: 'Toca', value: 'status_secacuerdos' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', sortable: false },
          ]
        }
        if (this.roleUser != 'abogado' && this.sala_id == 12) {
          return [
            { text: 'Asunto', value: 'status_secacuerdos', class: "title" },
            { text: 'Área', value: 'area', class: "title" },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'action', class: "title",  align: 'left', sortable: false },
            { text: '' },
          ]
        }

      },
      headersHistorial() {
        if (this.sala_id <= 11 ){
          return [
            { text: 'Toca', value: 'numero_completo' },
            { text: 'Área', value: 'area' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'acciones', sortable: false }
          ]
        }
        if (this.sala_id == 12 ){
          return [
            { text: 'Asunto', value: 'numero_completo' },
            { text: 'Estatus', value: 'status', sortable: false },
            { text: 'Registro de fechas', value: 'fechas' },
            { text: 'Acciones', value: 'accionesExp', sortable: false }
          ]
        }
      },
      ...mapGetters([
        "promocionesList", "roleUser", "listSalas", "listJueces", "currentUser"
      ])
    },
    watch:{
      status (val) {
        this.pagination.current = 1;
        // una sola llamada según sala_id (evita doble cuando sala_id == '' que cumple val<=11 y val=='')
        if (this.sala_id == 12) {
          this.buscarExpediente();
        } else if (this.sala_id == 13) {
          this.buscarBuzon();
        } else {
          // sala_id == '' , null, <=11
          this.getPromociones();
        }
      },
      no_toca (val){
        this.pagination.current = 1;
        if(!val){
          return this.$refs.search.resetValidation()
        }
      },
      no_expediente (val){
        this.pagination.current = 1;
        if(!val){
          // return this.$refs.search.resetValidation()
        }
      },
      sala_id (val){
        this.pagination.current = 1;
        this.leidos = '';
        // else-if evita doble llamada cuando val=='' ( '' <=11 es true y !val también true )
        if (!val || val === '') {
          this.active_tab = 'tab-1'
          this.getPromociones();
        } else if (val == 12) {
          this.no_toca = '';
          this.no_expediente = '';
          this.active_tab = 'tab-2'
          this.buscarExpediente();
        } else if (val == 13) {
          this.no_toca = '';
          this.no_expediente = '';
          this.active_tab = 'tab-3'
          this.buscarBuzon();
        } else if (val <= 11) {
          this.active_tab = 'tab-1'
          this.getPromociones();
        }
      },
    },
    mounted(){
      this.getSalas()
      this.getPendientes()
      if (this.currentUser.sala_id) {
        this.sala_id = this.currentUser.sala_id
      } else if (this.roleUser == 'superadmin' || this.roleUser == 'admin' || this.roleUser == 'abogado') {
        this.getPromociones()
      }
    },
    methods: {
      clickSearch(){
        this.titleTabla = 'RESULTADO DE LA BUSQUEDA:'
        this.loadingTable = true
        if (this.sala_id == 12) {
          this.buscarExpediente()
        } else if (this.sala_id == 13) {
          this.buscarBuzon()
        } else {
          this.getPromociones()
        }
      },
      onPageChange() {
        if (this.sala_id == 12) {
          this.buscarExpediente()
        } else if (this.sala_id == 13) {
          this.buscarBuzon()
        } else {
          this.getPromociones();
        }
      },
      onPageChangeHistorial() {
        if (this.sala_id == 12) {
          this.showHistorialExp()
        } else {
          this.showToca();
        }
      },
      validateLeidos(){
        var data = this.listData
        if (this.sala_id == 12) {
          this.leidos = data.some(leido => leido.laborales_pendientes_leer > 0);
          this.turnados = data.some(turnados => turnados.status_laborales > 0);
        } else if (this.sala_id == 13) {
          this.leidos = data.some(leido => leido.buzones_pendientes_leer == 0);
          this.turnados = data.some(turnados => turnados.fecha_contestacion == null);
        } else {
          this.leidos = data.some(leido => leido.promociones_pendientes_leer > 0);
          this.turnados = data.some(turnados => turnados.status_promociones > 0);
        }
      },
      buscarBuzon() {
        this.loadingTable = true;
        this.$store.dispatch("GET_BUZONES", {
          url:"/buzones?page="+this.pagination.current,
          params: {
            // tipo:this.tipo,
            status:this.status,
            sala_id:this.sala_id,
            // no_expediente:this.no_expediente
          }
        } )
        .then((response) => {
         // console.log(response.data);
          this.loadingTable = false
          this.pagination.current = response.data.data.buzones.current_page;
          this.pagination.total = response.data.data.buzones.last_page;
          this.per_page_table = response.data.data.buzones.per_page;
          this.listData = response.data.data.buzones.data;
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
          this.validateLeidos()
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },
      buscarExpediente() {
        this.loadingTable = true;
        this.$store.dispatch("GET_EXPEDIENTES", {
          url:"/expedientes?page="+this.pagination.current,
          params: {
            // tipo:this.tipo,
            status:this.status,
            sala_id:this.sala_id,
            no_expediente:this.no_expediente
          }
        } )
        .then((response) => {
        //  console.log(response.data);
          this.loadingTable = false
          this.pagination.current = response.data.data.expedientes.current_page;
          this.pagination.total = response.data.data.expedientes.last_page;
          this.per_page_table = response.data.data.expedientes.per_page;
          this.listData = response.data.data.expedientes.data;
          if (response.data.status == 'ok') {
            this.showTabla = true
            this.showAlert = false
          } else {
            this.showAlert = true
            this.showTabla = false
          }
          this.validateLeidos()
        })
        .catch(err => {
          console.log(err);
          this.showAlert = true
          this.showTabla = false
        });
      },
      showToca(item) {
        if (item) {
          this.toca_id = item.toca_id
          this.numero_completo = item.numero_completo
        }
        this.dialog = true
        this.listHistorial = []
        this.loadingHistorial = true
        this.$store.dispatch("GET_PROMOCIONES", {
          url:"/toca/"+this.toca_id+"/promociones?page="+this.paginationHistorial.current,
          params: {
            no_toca:this.numero_completo
          }
        } )
        .then((response) => {
          this.paginationHistorial.current = response.data.data.promociones.current_page;
          this.paginationHistorial.total = response.data.data.promociones.last_page;
          this.per_page_table_historial = response.data.data.promociones.per_page;
          this.listHistorial = response.data.data.promociones.data;
          this.loadingHistorial = false
        })
        .catch(err => {
          console.log(err);
          this.loadingHistorial = false
          // this.showAlert = true
          // this.showTabla = false
        });
      },
      // firmar(item){
      //   this.$store.dispatch("SHOW_PROMOCION", {
      //     url:"/promocion/"+ item.id,
      //   } )
      //   .then((response) => {
      //   this.$router.push('/firma/magistrado' )
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
      // },
      showPromocion(item){
        this.$store.dispatch("SHOW_PROMOCION", {
          url:"/promocion/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      getPromociones(item) {
        this.loadingTable = true
        this.$store.dispatch("GET_PROMOCIONES", {
            url:"/promociones?page="+this.pagination.current,
            params: {
              status:this.status,
              sala_id:this.sala_id,
              no_toca:this.no_toca
            }
          })
          .then((response) => {
            //console.log(response.data);
            this.loadingTable = false
            this.pagination.current = response.data.data.promociones.current_page;
            this.pagination.total = response.data.data.promociones.last_page;
            this.per_page_table = response.data.data.promociones.per_page;
            this.listData = response.data.data.promociones.data;
            if (response.data.status == 'ok') {
              this.showTabla = true
              this.showAlert = false
            } else {
              this.showAlert = true
              this.showTabla = false
            }
            this.validateLeidos()
          })
          .catch(err => {
            console.log(err);
          });
      },
      showExpediente(item){
        // console.log(item);
        this.$store.dispatch("SHOW_EXPEDIENTE", {
          url:"/expediente/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      showHistorialExp(item) {
        this.dialog = true
        this.numero_completo = item.numero_completo
        this.listHistorial = []
        this.loadingHistorial = true
        this.$store
          .dispatch("GET_ESCRITOS", {
            url:"/expediente/"+ item.expediente_id +"/escritos?page="+this.paginationHistorial.current,
            data: {
              id: item.id,
            }
          })
          .then((response) => {
            this.paginationHistorial.current = response.data.data.expedientes.current_page;
            this.paginationHistorial.total = response.data.data.expedientes.last_page;
            this.per_page_table_historial = response.data.data.expedientes.per_page;
            this.listHistorial = response.data.data.expedientes.data;
            this.loadingHistorial = false
            console.log(this.listHistorial);
          })
          .catch(err => {
            console.log(err);
            this.loadingHistorial = false
          });
      },
      getSalas() {
        this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
        })
        .catch(error => {
          console.log(error);
        });
      },
      showBuzon(item){
        // console.log(item);
        this.$store.dispatch("SHOW_BUZON", {
          url:"/buzon/"+ item.id,
        } )
        .then((response) => {
        this.$router.push('/escritos/show' )
        })
        .catch(err => {
          console.log(err);
        });
      },
      getPendientes() {
        this.salaSelected = ''
        this.$store.dispatch("GET_PENDIENTES_LEER",  { url: "/abogado/pendientes-leer",
        }).then(response => {
            this.pendientesLeer = response.data.data
          // console.log(response.data);
        })
        .catch(err => {
          console.log(err);
        });
      },
      clear() {
        if (!this.no_toca && !this.no_expediente ) {
          this.$refs.search.resetValidation()
          //this.validateToca = true
        }
      },
      close() {
        this.dialog = false
        this.paginationHistorial.current = 1
      },
    }
  };
</script>
